import {createContext} from "react";

export const JobFilterContext = createContext({
    languagePairs: [],
    workTypes: []
});